export { getNormalizedPercentageFromValue, getNormalizedValueFromPercentage, getPercentageFromValue, getValueFromPercentage, percentageToCSSValue } from './percentageUtils/index.js';
export { TimeCounter } from './TimeCounter/TimeCounter.js';
export { getParamValueFromUrl, isAbsoluteURL } from './urlUtils/index.js';
export { base64DecodeUnicode, base64UrlDecode, isTokenExpired, jwtDecode } from './jwt.js';
export { FORGEROCK_ACCOUNT_TYPES, MSO_PROVIDERS_TYPES, USER_TYPES, getMSOProviderFormatted, getUserTypeByBusinessUnit } from './user.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/classPrivateFieldLooseBase';
import '@babel/runtime/helpers/esm/classPrivateFieldLooseKey';
import '@babel/runtime/helpers/esm/defineProperty';

/**
 * Returns an object with methods to check if the user is using an Android device, iOS device,
 * or any mobile device.
 * @return An object with methods to check for specific mobile devices.
 */
function isMobile() {
  return {
    Android: function Android() {
      return !!/android/i.test(navigator.userAgent);
    },
    iOS: function iOS() {
      return !!/iphone|ipad|ipod/i.test(navigator.userAgent);
    },
    any: function any() {
      return !!(this.Android() || this.iOS());
    }
  };
}

/**
 * Returns the initials of each word in the input sentence.
 *
 * @param {string} sentence - The input sentence to extract initials from
 * @return {string[]} An array of initials for each word in the sentence
 */
function getInitials(sentence) {
  return sentence === null || sentence === void 0 ? void 0 : sentence.replace(/,/g, '').split(/\s/).filter(Boolean).map(function (word) {
    return word[0];
  });
}

/**
 * Returns a throttled function that ensures the original function
 * is only called once until the previous operation promise is resolved.
 *
 * @param {(...args: T) => S} fn - The original function to be throttled.
 * @returns {(...args: T) => S} - The throttled function.
 * @template {any[]} T
 * @template {Promise<any>} S
 */
function throttleUntilResolve(fn) {
  var currentOperationPromise;
  return function () {
    if (currentOperationPromise) return currentOperationPromise;
    currentOperationPromise = fn.apply(void 0, arguments);
    return currentOperationPromise["finally"](function () {
      currentOperationPromise = undefined;
    });
  };
}

export { getInitials, isMobile, throttleUntilResolve };
//# sourceMappingURL=index.js.map
